import React, { useEffect, useState, useRef } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { wp } from "../api/WpApi";
import { withRouter } from "./WithRouter"; // https://stackoverflow.com/a/71043072
// import WpComments from "react-wordpress-comments";
import WpComments from "./wpComments";
import "../../styles/wpCommentStyles.scss";
import "../../styles/wprmStyles.scss";
// import "react-wordpress-comments/css/styles.css";
import WpService from "./WpService";
import RecipeSchemaService from "../seo/RecipeSchemaService";
import RecipeDataService from "../seo/RecipeDataService";
import RatingStars from "./wpComments/ratingStars";
import RecipeHelpers from '../helpers/RecipeHelpers';

import Breadcrumbs from "../helpers/Breadcrumbs";
import { removeBreadcrumbs } from "../seo/RemoveBreadcrumbs";

import { Helmet } from "react-helmet";
import parse from "html-react-parser";

import data from "./_setup.json";

import PageLoading from "./PageLoading";
import { PostBadge } from "../alerts/PostBadge";
import NotFoundPage from "../../pages/errors/NotFoundPage";

const PostView = () => {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [tags, setTags] = useState([]);
  const [posts, setPosts] = useState(null);
  const [wakeLock, setWakeLock] = useState(null);
  const [wakeLockActive, setWakeLockActive] = useState(false);
  const [wprmSchema, setWprmSchema] = useState(null);
  const [scaleFactor, setScaleFactor] = useState(1);
  const [unitSystem, setUnitSystem] = useState('metric'); // default to imperial, can be changed by user
  const contentRef = useRef(null);

  // Request wake lock
  const requestWakeLock = async () => {
    try {
      const lock = await navigator.wakeLock.request("screen");
      setWakeLock(lock);
      setWakeLockActive(true);

      // If lock is released automatically (e.g., tab hidden), listen and reset
      lock.addEventListener("release", () => {
        setWakeLockActive(false);
      });
    } catch (err) {
      console.error("Wake Lock request failed:", err);
    }
  };

  // Release wake lock
  const releaseWakeLock = async () => {
    try {
      if (wakeLock) {
        await wakeLock.release();
        setWakeLock(null);
        setWakeLockActive(false);
      }
    } catch (err) {
      console.error("Wake Lock release failed:", err);
    }
  };

  // Toggle wake lock
  const toggleWakeLock = async () => {
    if (wakeLockActive) {
      releaseWakeLock();
    } else {
      requestWakeLock();
    }
  };

  // function extractKKStarRatings(html) {
  //   const match = html.match(
  //     /<div class="kk-star-ratings[\s\S]*?<\/div>\s*<\/div>/
  //   );
  //   return match ? match[0] : null;
  // }

  let navigate = useNavigate();
  let { postName } = useParams();

  useEffect(() => {
    getPost(postName ? postName : "404");
  }, [postName]);

useEffect(() => {
  if (!posts) return;

  const commentsUrl = `${process.env.REACT_APP_WP_HOST_PAGE}/wp-json/wp/v2/comments?post=${posts.id}&per_page=100`;

  fetch(commentsUrl)
    .then((res) => (res.ok ? res.json() : []))
    .then((comments) => {
      const schema = RecipeSchemaService.extractWprmSchemaFromContent(
        posts.content.rendered,
        posts,
        comments,
        tags
      );
      setWprmSchema(schema);
    })
    .catch((err) => {
      console.error("Error fetching comments for schema:", err);
      const schema = RecipeSchemaService.extractWprmSchemaFromContent(posts.content.rendered, posts, [], tags);
      setWprmSchema(schema);
    });
}, [posts, tags]);

  useEffect(() => {
    if (!contentRef.current || !posts) return;

    // Find ingredients
    const ingredients = contentRef.current.querySelectorAll('.wprm-recipe-ingredient');
    if (ingredients.length === 0) return;

    // Find header
    const header = contentRef.current.querySelector('.wprm-recipe-ingredients-header');
    if (header) {
      // Make header flex
      header.style.display = 'flex';
      header.style.justifyContent = 'space-between';
      header.style.alignItems = 'center';

      // Add scaling buttons
      let scaleContainer = header.querySelector('.scale-buttons');
      if (!scaleContainer) {
        scaleContainer = document.createElement('div');
        scaleContainer.className = 'scale-buttons btn-group btn-group-sm';
        header.appendChild(scaleContainer);
      }

      scaleContainer.innerHTML = `
        <button class="btn ${scaleFactor === 0.5 ? 'btn-primary' : 'btn-outline-primary'}" data-factor="0.5">x1/2</button>
        <button class="btn ${scaleFactor === 1 ? 'btn-primary' : 'btn-outline-primary'}" data-factor="1">x1</button>
        <button class="btn ${scaleFactor === 2 ? 'btn-primary' : 'btn-outline-primary'}" data-factor="2">x2</button>
      `;

      scaleContainer.querySelectorAll('button').forEach(btn => {
        btn.addEventListener('click', () => setScaleFactor(parseFloat(btn.dataset.factor)));
      });

      // // Add unit buttons below
      // let unitContainer = header.nextElementSibling;
      // if (!unitContainer || !unitContainer.classList.contains('unit-buttons')) {
      //   unitContainer = document.createElement('div');
      //   unitContainer.className = 'unit-buttons btn-group btn-group-sm my-2';
      //   unitContainer.ariaLabel = "Unit system toggle";
      //   header.parentNode.insertBefore(unitContainer, header.nextSibling);
      // }

      // unitContainer.innerHTML = `
      //   <button class="btn ${unitSystem === 'metric' ? 'btn-primary' : 'btn-outline-primary'}" data-system="metric">Metric</button>
      //   <button class="btn ${unitSystem === 'imperial' ? 'btn-primary' : 'btn-outline-primary'}" data-system="imperial">Imperial</button>
      // `;

      // unitContainer.querySelectorAll('button').forEach(btn => {
      //   btn.addEventListener('click', () => setUnitSystem(btn.dataset.system));
      // });
    }

    // Scale and convert amounts
    const amounts = contentRef.current.querySelectorAll('.wprm-recipe-ingredient-amount');
    amounts.forEach(amountEl => {
      const originalAmount = amountEl.dataset.originalAmount || amountEl.textContent.trim();
      amountEl.dataset.originalAmount = originalAmount;

      const ingredientEl = amountEl.closest('.wprm-recipe-ingredient');
      const unitEl = ingredientEl.querySelector('.wprm-recipe-ingredient-unit');
      const originalUnit = unitEl ? (unitEl.dataset.originalUnit || unitEl.textContent.trim()) : '';
      if (unitEl) unitEl.dataset.originalUnit = originalUnit;

      // Scale
      const scaledAmount = RecipeHelpers.scaleAmount(originalAmount, scaleFactor);
      

      // Convert
      // const { amount: finalAmount, unit: finalUnit } = RecipeHelpers.convertUnit(scaledAmount, originalUnit, unitSystem);
      // const { amount: finalAmount, unit: finalUnit } = RecipeHelpers.convertUnit(scaledAmount, originalUnit, unitSystem);
      const finalAmount = scaledAmount; // for now, skip unit conversion
      const finalUnit = originalUnit; // for now, skip unit conversion
      
      amountEl.textContent = finalAmount;
      if (unitEl) unitEl.textContent = finalUnit;

      // ensure spaces around amount/unit and ingredient text
      if (amountEl.nextSibling && amountEl.nextSibling.nodeType === Node.ELEMENT_NODE) {
        // if next sibling is unit span, ensure a space before it
        amountEl.insertAdjacentText('afterend', ' ');
      }
      if (unitEl) {
        // ensure space after unit before the ingredient name/text
        if (unitEl.nextSibling?.nodeType === Node.TEXT_NODE) {
          const txt = unitEl.nextSibling.textContent;
          if (!txt.startsWith(' ')) {
            unitEl.nextSibling.textContent = ' ' + txt;
          }
        } else {
          unitEl.insertAdjacentText('afterend', ' ');
        }
      }

    });

    // add checkboxes after adjusting amounts
    ingredients.forEach(ing => {
      if (!ing.querySelector('.ingredient-checkbox')) {
        const checkbox = document.createElement('input');
        checkbox.type = 'checkbox';
        checkbox.className = 'ingredient-checkbox';
        checkbox.style.marginRight = '5px';

        // wrap text in label to make clickable
        const label = document.createElement('label');
        label.style.cursor = 'pointer';
        // use inline-flex with wrap so the label itself flows inline, 
        // and child flex items wrap naturally like before
        label.style.display = 'inline-flex';
        label.style.flexWrap = 'wrap';
        label.style.alignItems = 'center';
        label.style.gap = '0.25rem';
        label.appendChild(checkbox);

        const content = ing.innerHTML;
        ing.innerHTML = '';
        ing.appendChild(label);
        label.insertAdjacentHTML('beforeend', content);

        checkbox.addEventListener('change', () => {
          const target = label; // apply styles on the label so it affects the inner text
          const ingredientId = ing.dataset.uid; // Get the ingredient ID from data-uid
          
          if (checkbox.checked) {
            target.style.textDecoration = 'line-through';
            target.style.opacity = '0.5';
            
            // Find and mark the corresponding instruction ingredients with checkmark
            // The class pattern is: wprm-recipe-instruction-ingredient-{recipeId}-{ingredientId}
            const instructionIngredients = contentRef.current.querySelectorAll(
              `[class*="wprm-recipe-instruction-ingredient-"][class*="-${ingredientId}"]`
            );
            instructionIngredients.forEach(instrIng => {
              // Verify it ends with our ingredient ID to avoid false matches
              const className = instrIng.className;
              const match = className.match(/wprm-recipe-instruction-ingredient-\d+-(\d+)/);
              if (match && match[1] === ingredientId) {
                // Remove existing checkmark if present
                const existingCheckmark = instrIng.querySelector('.ingredient-checkmark');
                if (existingCheckmark) existingCheckmark.remove();
                
                // Add checkmark icon
                const checkmark = document.createElement('i');
                checkmark.className = 'bi bi-check2 ingredient-checkmark';
                checkmark.style.marginLeft = '5px';
                instrIng.appendChild(checkmark);
              }
            });
          } else {
            target.style.textDecoration = 'none';
            target.style.opacity = '1';
            
            // Remove checkmark from instruction ingredients
            const instructionIngredients = contentRef.current.querySelectorAll(
              `[class*="wprm-recipe-instruction-ingredient-"][class*="-${ingredientId}"]`
            );
            instructionIngredients.forEach(instrIng => {
              const className = instrIng.className;
              const match = className.match(/wprm-recipe-instruction-ingredient-\d+-(\d+)/);
              if (match && match[1] === ingredientId) {
                const checkmark = instrIng.querySelector('.ingredient-checkmark');
                if (checkmark) checkmark.remove();
              }
            });
          }
        });
      }
    });
  }, [posts, scaleFactor, unitSystem]);

  const printRecipe = () => {
    window.print();
  };
  const scrollToRecipe = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      window.history.replaceState(null, "", `#${id}`); // This replaces the URL without adding a new entry
    }
  };

  const getPost = (s) => {
    // Fetch post with slug "xyz": http://wp-api.org/node-wpapi/using-the-client/#api-query-parameters
    wp.posts()
      .slug(s)
      .then((posts) => {
        setIsLoading(false);
        setPosts(posts[0]); // Get first element from array
        setTags(WpService.getItemFromClassList(posts[0].class_list, "tag-"));
      })
      .catch((error) => {
        setError(error);
        setIsLoading(false);
      });
  };

  // const location = useLocation();
  if (error) {
    console.log("error...");
    return <div className="content error">
      <Helmet>
        <meta name="robots" content="noindex"></meta>
      </Helmet>
      Error: {error.message}</div>;
  } else if (isLoading) {
    console.log("loading...");
    return (
      <div>
        <PageLoading />
      </div>
    );
  } else if (posts !== null && posts !== undefined) {
    const breadcrumbsItems = [
      { name: "Home", url: "/" },
      { name: "All Recipes", url: `/${data.url.slug_posts}/` },
      {
        name: (posts.title && posts.title.rendered) || posts.title !== undefined ? posts.title.rendered : posts.slug,
        url: `/${data.url.slug_posts}/${posts.slug}/`,
      },
    ];
    // compute recipe meta once
    const recipeData = RecipeDataService.extractRecipeData(posts.content.rendered);
    
    // responsive rating + meta block (placed before the rendered content)
    const ratingValue = recipeData.wprm_recipe_rating_average ? Number(recipeData.wprm_recipe_rating_average) : 0;
    const ratingCount = recipeData.wprm_recipe_rating_count ? Number(recipeData.wprm_recipe_rating_count) : 0;

    // Create a clean copy and filter out the BreadcrumbList
    const filteredSchema = removeBreadcrumbs(posts.yoast_head_json.schema, process.env.REACT_APP_PUBLIC_URL);
    // Augment Article schema to explicitly reference the Recipe JSON-LD as mainEntity
    let augmentedSchema = filteredSchema;
    try {
      const recipeId = wprmSchema && wprmSchema['@id'] ? wprmSchema['@id'] : (posts && posts.link ? `${posts.link}#recipe` : null);
      if (recipeId) {
        const recipeRef = { "@id": recipeId };
        if (Array.isArray(augmentedSchema)) {
          augmentedSchema = augmentedSchema.map((node) => {
            if (node && node['@type'] && /Article|NewsArticle|BlogPosting/i.test(node['@type'])) {
              return Object.assign({}, node, { mainEntity: node.mainEntity || recipeRef });
            }
            return node;
          });
        } else if (augmentedSchema && augmentedSchema['@type'] && /Article|NewsArticle|BlogPosting/i.test(augmentedSchema['@type'])) {
          augmentedSchema = Object.assign({}, augmentedSchema, { mainEntity: augmentedSchema.mainEntity || recipeRef });
        }
      }
    } catch (e) {
      // non-fatal: keep original filteredSchema
      augmentedSchema = filteredSchema;
    }

    return (
      <div className="post container">
        <br />
        <div className="flex justify-between" id="back-top">
          <button
            onClick={() => navigate(-1)}
            className="btn btn-outline-secondary"
          >
            Back
          </button>

          {/* <svg
            className="w-4 h-4 text-yellow-300 me-1"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            viewBox="0 0 22 20"
          >
            <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
          </svg>
          <p className="ms-2 text-sm font-bold text-gray-900 dark:text-white">
            {this.parseStarRating(post.content.rendered)}
          </p> */}
          <div className="text-right">
            <small className="text-muted">
              {new Date(posts.date).toLocaleDateString(
                data.format.date.locale,
                data.format.date.options
              )}
            </small>
            {posts.author === 2 && (
              <PostBadge
                link={false}
                text="Andrew's Original"
                style="post-badge"
                color="success"
              ></PostBadge>
            )}
          </div>
        </div>
        <h1
          className="text-center wp-post-title md:mx-auto"
          dangerouslySetInnerHTML={{ __html: posts.title.rendered }}
        />
        <Breadcrumbs items={breadcrumbsItems} styles={"md:text-base text-sm breadcrumb-nav my-2"} />
        <hr />
        <div className="grid md:grid-cols-6 grid-cols-1 md:justify-between">
          {tags && tags.length > 0 && (
          <div className="post-tag order-3 col-span-1">
            <div>
              Keywords:
              <div className="container">
                {tags.map((item) => (
                  <PostBadge
                    key={item}
                    link={true}
                    linkUrl={`/${data.url.slug_posts}/tag/${encodeURIComponent(
                      item
                    )}/`}
                      text={item}
                      style="child-tag"
                      color="danger"
                    />
                ))}
              </div>
            </div>
          </div>  
          )}
          <div className="container order-1 col-span-1">
            {posts.content.rendered.includes('id="recipe"') && (
              <div>
                <div className="jump-to-recipe-button md:mb-2">
                  <button
                    className="btn btn-primary"
                    type="button"
                    onClick={() => scrollToRecipe("recipe")}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-caret-down"
                      viewBox="0 0 16 16"
                    >
                      <path d="M3.204 5h9.592L8 10.481zm-.753.659 4.796 5.48a1 1 0 0 0 1.506 0l4.796-5.48c.566-.647.106-1.659-.753-1.659H3.204a1 1 0 0 0-.753 1.659" />
                    </svg>{" "}
                    Jump to Recipe
                  </button>
                </div>
                <div className="jump-to-recipe-button">
                  <button
                    className="btn btn-primary"
                    // href={"/wprm_print/" + posts.slug}
                    // target="_blank"
                    onClick={printRecipe}
                
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-printer"
                      viewBox="0 0 16 16"
                    >
                      <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1" />
                      <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1" />
                    </svg>{" "}
                    Print Recipe
                  </button>
                </div>
              </div>
            )}
          </div>
                    {/* Recipe rating + meta */}
          <div className="post-text-wrapper order-2 col-span-4 mb-4">
            <div id="recipeMetaData" className="grid grid-cols-2 grid-rows-[35%_65%] grid-rows-2 gap-2 mb-3 md:grid-cols-3 md:grid-rows-1 md:items-center md:justify-between">
              {ratingValue > 0 &&
                <div className="flex items-center justify-center md:justify-start col-span-2 md:col-span-1 md:row-span-1">
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <RatingStars
                      ratingValue={ratingValue}
                      isReadOnly={true}
                      totalStars={5}
                      size={20}
                      label="Recipe Rating"
                    />
                    <div className="text-sm text-muted">
                      {ratingCount ? `(${ratingValue}/5)` : ""}
                    </div>
                  </div>
                </div>}
              <div className="wprm-rating-display md:text-center text-left col-span-1 md:row-span-1">
                {(recipeData.prepTimeMinutes || recipeData.prepTimeHours || recipeData.prepTimeDays) && (
                  <div className="text-sm pb-1">
                    {/* <i class="bi bi-measuring-cup"></i> */}
                    <i class="bi bi-hourglass-top"></i> <strong>Prep:</strong> {recipeData.prepTimeDays}{" "}{recipeData.prepTimeHours}{" "}{ recipeData.prepTimeMinutes}
                  </div>
                )}
                 {(recipeData.customTimeLabel || recipeData.customTimeMinutes || recipeData.customTimeHours || recipeData.customTimeDays) && (
                  <div className="text-sm pb-1">
                    <i class="bi bi-alarm"></i> <strong>{recipeData.customTimeLabel}:</strong> {recipeData.customTimeDays}{" "}{recipeData.customTimeHours}{" "}{ recipeData.customTimeMinutes}
                  </div>
                )}
                 {(recipeData.cookTimeMinutes || recipeData.cookTimeHours || recipeData.cookTimeDays) && (
                  <div className="text-sm">
                    <i class="bi bi-hourglass-split"></i> <strong>Cooking:</strong> {recipeData.cookTimeDays}{" "}{recipeData.cookTimeHours}{" "}{ recipeData.cookTimeMinutes}
                  </div>
                )}
                
                {(recipeData.totalTimeMinutes || recipeData.totalTimeHours || recipeData.totalTimeDays) && (
                  <div>
                    <hr className="m-1" />
                    <div className="text-sm">
                      <i class="bi bi-clock"></i> <strong>Total Time:</strong> {recipeData.totalTimeDays}{" "}{recipeData.totalTimeHours}{" "}{ recipeData.totalTimeMinutes}
                    </div>
                  </div>
                  
                )}
              </div>
          
              <div className="wprm-rating-display md:text-center text-right col-span-1 md:col-start-3 md:row-span-1">
                {recipeData.wprm_cost && (
                  <div className="text-sm pb-1">
                    <strong>Cost:</strong> <span className="text-green-500">{recipeData.wprm_cost}</span>
                  </div>
                )}
                {recipeData.calories && (
                  <div className="text-sm pb-1">
                    
                    <strong>Calories:</strong> <i class="bi bi-fire"></i> {recipeData.calories} kcal
                  </div>
                )}
                {recipeData.servings && (
                  <div className="text-sm pb-1">
                    <strong>Servings:</strong> <i class="bi bi-people-fill"></i> {recipeData.servings} {recipeData.servingsUnit}
                  </div>
                )}
              </div>

            </div>

            {
             recipeData.ingredients.length !== 0 && (<hr id="recipeMetaData" className="m-2"/>)
            }

            <div
            ref={contentRef}
            className="text-left md:order-4"
            dangerouslySetInnerHTML={{ __html: posts.content.rendered }}
            />
            
            {recipeData.cuisine.length !== 0 && (
              <div>
                <hr />
                <div className="text-left"><strong>Cuisine:{" "}</strong><span>{recipeData.cuisine}</span></div>
              </div>
            )}
          </div>
        </div>
          
        <div className="text-center">
          <Link
            to={"/" + data.url.slug_posts + "/"}
            className="btn btn-secondary"
          >
            Back to Recipes
          </Link>
        </div>
        <hr />
        <div className="container form-group" id="respond">
          {posts.comment_status === "open" && (
            <WpComments
              maxDepth={3} // provide depth that you want comments to be nested in a list
              pageId={posts.id} // id of a page you want to fetch comments from and post to
              hostUrl={process.env.REACT_APP_WP_HOST_PAGE} // url of your WordPress website
              allowComments={true} // can users post comments?
              user={null} // provide user if authorized, default is null. See below
              showStarRating={
                !!(
                  posts.content &&
                  posts.content.rendered &&
                  /class=(["'])[^\1]*\bwprm-recipe\b[^\1]*\1/.test(posts.content.rendered)
                )
              }
              className="form-control"
            />
          )}
        </div>

        {/* Floating action buttons */}
        <div className="fixed bottom-[5%] inset-x-0 middle md:hidden z-50">
          {/* Keep screen awake toggle */}
          {"wakeLock" in navigator && (
            <button
              onClick={toggleWakeLock}
              className={`p-3 rounded-full shadow-lg btn ${
                wakeLockActive
                  ? "bg-danger  text-white fw-bold bg-opacity-75"
                  : "bg-warning text-black fw-bold"
              }`}
              aria-label="Keep screen awake"
              title={
                wakeLockActive ? "Disable screen awake" : "Keep screen awake"
              }
            >
              {wakeLockActive ? <div><i class="bi bi-lock-fill"></i> Unlock Screen</div> : <div><i class="bi bi-unlock-fill"></i> Keep Screen Awake</div>}
            </button>
          )}
        </div>
        {posts.yoast_head != null && posts.yoast_head !== undefined && (
          <div>
            <Helmet>{parse(posts.yoast_head)}</Helmet>

            <Helmet>
              <script type="application/ld+json">
                {
                  JSON.stringify(filteredSchema)
                }
              </script>
            </Helmet>
          </div>
        )}
        {posts.content.rendered.includes('id="recipe"') && wprmSchema && (
          <Helmet>
            <script type="application/ld+json">
              {JSON.stringify(wprmSchema)}
            </script>
          </Helmet>
        )}
        {tags != null && (
          <Helmet>
            <meta name="parsely-tags" content={tags.join(",")}></meta>
          </Helmet>
        )}

        <hr />
      </div>
    );
  } else {
    return (
      <NotFoundPage/>
    );
  }
};

export default withRouter(PostView);
